import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiUsers, FiBriefcase, FiAward } = FiIcons;

const STATS = [
  { label: 'Workers Trained', value: '5,000+', icon: FiUsers },
  { label: 'Corporate Clients', value: '100+', icon: FiBriefcase },
  { label: 'Training Satisfaction', value: '98%', icon: FiAward },
];

const Stats = () => {
  return (
    <section className="relative z-30 -mt-16 sm:-mt-24 pb-12">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {STATS.map((stat, index) => (
            <motion.div 
              key={stat.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="glass-panel rounded-xl p-8 flex items-center gap-6"
            >
              <div className="w-16 h-16 rounded-full bg-alpha-navy/10 flex items-center justify-center flex-shrink-0">
                <SafeIcon icon={stat.icon} className="text-3xl text-alpha-navy" />
              </div>
              <div>
                <h3 className="text-3xl font-bold text-alpha-navy mb-1">{stat.value}</h3>
                <p className="text-alpha-grayDark font-medium">{stat.label}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;